require('../js/bootstrap');

import React from 'react';

import ReactDOM from 'react-dom';

import moment from "moment";

moment.locale('de');

import {default as Home} from './views/home';

ReactDOM.render(
    <Home/>,
    document.getElementById('root')
);
